<template lang="pug">
  .support-tile
    Icon.icon(name="24hrs")
    .title Возникли проблемы?
    .subtitle Обратитесь в техподдержку
    Btn(round xl href="mailto:support@teroom.ru") support@teroom.ru
</template>

<script>
export default {
  name: 'SupportTile',
};
</script>

<style scoped lang="scss">
  .support-tile {
    padding: 56px 20px;
    background: #FFFFFF;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .icon {
    margin-bottom: 20px;
  }

  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.01em;
    color: #1E3147;
    margin-bottom: 4px;
  }

  .subtitle {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #788CA1;
    margin-bottom: 17px;
  }
</style>
